import CustomCard from '../../cards/CustomCard';
import SearchForm from '../SearchForm';

interface SearchFormCardProps {
  startSearch: () => void;
}

function SearchFormCard({ startSearch }: SearchFormCardProps) {
  return (
    <div className='search-filter-card-container'>
      <CustomCard>
        <SearchForm startSearch={startSearch} />
      </CustomCard>
    </div>
  );
}

export default SearchFormCard;
